module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "drawerContainer",
    staticClass: "drawer-container",
    class: {
      'drawer-container-active': _vm.isDrawerActive
    },
    on: {
      "click": _vm.hideDrawer,
      "touchstart": function($event) {
        _vm.onTouchstart($event)
      },
      "touchmove": function($event) {
        _vm.onTouchMove($event)
      },
      "touchend": function($event) {
        _vm.onTouchEnd($event)
      }
    }
  }, [_c('div', {
    ref: "drawerPanel",
    staticClass: "drawer-panel",
    class: {
      'drawer-panel-active': _vm.isDrawerActive, 'drawer-panel-no-transition': _vm.noPanelTransition
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "touchstart": function($event) {
        _vm.onTouchstart($event)
      },
      "touchmove": function($event) {
        _vm.onTouchMove($event)
      },
      "touchend": function($event) {
        _vm.onTouchEnd($event)
      }
    }
  }, [_c('div', {
    staticClass: "drawer-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "drawer-content"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "drawer-link",
    on: {
      "click": _vm.hideDrawer
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "24px",
      "height": "24px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Home")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('div', {
    staticClass: "drawer-link",
    on: {
      "click": _vm.hideDrawer
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "24px",
      "height": "24px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("About Us")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('div', {
    staticClass: "drawer-link",
    on: {
      "click": _vm.hideDrawer
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "24px",
      "height": "24px"
    },
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M16,18H7V4H16M11.5,22A1.5,1.5 0 0,1 10,20.5A1.5,1.5 0 0,1 11.5,19A1.5,1.5 0 0,1 13,20.5A1.5,1.5 0 0,1 11.5,22M15.5,1H7.5A2.5,2.5 0 0,0 5,3.5V20.5A2.5,2.5 0 0,0 7.5,23H15.5A2.5,2.5 0 0,0 18,20.5V3.5A2.5,2.5 0 0,0 15.5,1Z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Contact Us")])])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-288abdb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Drawer.vue
// module id = 258
// module chunks = 6